import { X, Linkedin } from "lucide-react";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import StructuredData from "./StructuredData";

export default function NotreEquipe() {
  const [selectedMember, setSelectedMember] = useState(null);

  const teamMembers = [
    {
      id: 1,
      name: "Nabil El Madani",
      role: "Fondateur & CEO",
      subRole: "Fondateur & CEO",
      image: "/images/nabil_elmadani.png",
      imagePosition: "center top",
      linkedin: "https://linkedin.com/in/nabil-elmadani",
      shortBio: "Fondateur et CEO de BankElys avec 35 années d'expérience en direction bancaire et financière. Ancien Directeur Général de la Banque Zitouna et Président Directeur Général de La Poste Tunisienne.",
      fullBio: `Nabil El Madani est un dirigeant tunisien au parcours exceptionnel, cumulant plus de trente-cinq années d'expérience dans les domaines bancaire, financier et institutionnel. Visionnaire et rigoureux, il a consacré sa carrière au développement de stratégies de croissance, à la transformation digitale et à la modernisation de la gouvernance des institutions financières tunisiennes.

Depuis juillet 2025, il est le promoteur et dirigeant du cabinet BankElys, une structure de conseil dédiée à l'accompagnement des opérateurs économiques dans leurs opérations, leur financement international et leurs stratégies de développement.

Sous son impulsion, BankElys s'impose comme un acteur de référence, conjuguant expertise technique, innovation et éthique professionnelle.

Avant de fonder BankElys, Nabil El Madani a exercé de hautes fonctions de direction au sein de plusieurs institutions de premier plan. Il a notamment été Directeur Général de la Banque Zitouna de septembre 2019 à avril 2025, après y avoir occupé plusieurs postes stratégiques tels que Secrétaire Général, Conseiller du Directeur Général, et Responsable du Développement Clientèle.

Il a également dirigé la Poste Tunisienne en qualité de Président Directeur Général (2013–2015), assurant la modernisation des services financiers postaux et la promotion de l'inclusion financière.

Auparavant, il a occupé des fonctions de responsabilité au sein d'Attijari Bank et du groupe Alfa, où il a piloté d'importants projets de restructuration et de performance.

Membre et président de plusieurs conseils d'administration (Zitouna Tamkeen, Zitouna Takaful, Zitouna Payment, Tunisie Telecom, Cotunace, STIP…), il a contribué activement à la gouvernance et à la stratégie de développement d'institutions clés du paysage économique tunisien.

Parallèlement à ses activités de dirigeant, Nabil El Madani s'investit dans la formation et le transfert de compétences. Enseignant à l'Institut de Financement du Développement du Maghreb Arabe (IFID), il forme depuis plus de quinze ans des générations de cadres et de professionnels du secteur bancaire.

Polyglotte (arabe, français, anglais) et passionné de développement durable, il défend une vision humaniste et responsable de la finance :

« La finance doit être au service du progrès humain et du développement durable. »`
    },
    {
      id: 2,
      name: "Sihem Feriani",
      role: "Expert Senior en Finance",
      subRole: "Expert Senior en Finance",
      image: "/images/sihem_feriani.png",
      imagePosition: "center top",
      linkedin: "https://linkedin.com/in/sihem-feriani",
      shortBio: "Leader reconnue avec 25 années d'expérience au sein d'Attijari Bank, experte en transformation opérationnelle, conformité et développement des ressources humaines à l'échelle nationale.",
      fullBio: `Sihem Feriani est une professionnelle accomplie du secteur bancaire, forte de plus de vingt-cinq années d'expérience au sein d'Attijari Bank, où elle a su allier excellence opérationnelle, leadership humain et vision stratégique. Son parcours s'est construit autour de trois axes majeurs : la transformation opérationnelle, le développement des talents et le pilotage de projets structurants à fort impact organisationnel.

Au fil des années, elle a occupé des postes de responsabilité croissante, passant de la gestion opérationnelle d'agences bancaires à la conduite de projets stratégiques menés en étroite collaboration avec le cabinet McKinsey. Cette expérience lui a permis d'acquérir une maîtrise approfondie des processus de transformation, de la conduite du changement et de la coordination transverse dans des environnements exigeants et complexes.

Visionnaire et pragmatique, Sihem Feriani s'est distinguée par sa capacité à mobiliser les équipes autour d'objectifs communs, à structurer les priorités stratégiques et à garantir la performance durable des organisations qu'elle pilote. Elle a notamment conduit la refonte des dispositifs de conformité et de contrôle interne, la mise en place de contrôles à distance, ainsi que la structuration des dispositifs RH à l'échelle nationale, incluant les plans de relève, la mobilité interne et la formation continue. Son rôle dans la coordination des projets logistiques et d'optimisation des achats stratégiques au niveau du réseau témoigne de son aptitude à concilier rigueur, agilité et sens du résultat.

Animée par un profond engagement envers l'excellence et la transmission, Sihem Feriani incarne un modèle de leadership moderne, fondé sur la responsabilité, la collaboration et l'innovation managériale.`
    },
    {
      id: 3,
      name: "Amina Guizani",
      role: "Expert Senior en Finance",
      subRole: "Expert Senior en Finance",
      image: "/images/amina_guizani.png",
      imagePosition: "center top",
      linkedin: "https://linkedin.com/in/amina-guizani",
      shortBio: "Experte en finance internationale avec 32 ans d'expérience chez Attijari Bank Tunisie. Spécialisée en opérations de commerce extérieur, crédits documentaires et pilotage de projets stratégiques.",
      fullBio: `Amina Guizani, avec ses 32 ans d'expérience professionnelle, a évolué au sein d'Attijari Bank Tunisie où elle s'est imposée comme experte métier dans les opérations internationales.

Forte d'une expérience riche et diversifiée, elle a successivement assuré la responsabilité de plusieurs services stratégiques au sein de la banque, couvrant aussi bien les activités de commerce extérieur que les opérations de trésorerie et de conformité réglementaire.

Son parcours débute dans le service étranger d'une agence bancaire, où elle se distingue par sa maîtrise des opérations internationales et son sens aigu du service client. Elle est ensuite nommée responsable du service export, assurant la supervision des crédits documentaires, remises, garanties et transactions liées aux échanges extérieurs.

Progressivement, elle étend ses compétences à la trésorerie en dinars, au back office devises, ainsi qu'au suivi des déclarations destinées à la Banque Centrale de Tunisie, domaines dans lesquels elle met en place des procédures optimisées garantissant la rigueur, la conformité et la fluidité des flux financiers.

Amina Guizani a également joué un rôle déterminant dans le pilotage de projets bancaires structurants, notamment le SGMT (Système de Gestion des Montants de Transfert), un dispositif clé pour le traitement des virements de gros montants (RTGS). Son approche analytique, sa vision opérationnelle et sa capacité à fédérer les équipes autour d'objectifs communs ont contribué au succès de ce projet majeur pour la banque.

Parallèlement à ses fonctions, elle s'investit dans la formation interne en tant que formatrice à l'Attijari Académie, partageant son savoir-faire et son expérience avec les nouvelles générations de collaborateurs.

Animée par la rigueur, l'excellence opérationnelle et le développement des talents, Amina Guizani incarne une nouvelle génération de cadres bancaires conjuguant expertise technique, leadership et engagement institutionnel.`
    }
  ];

  const teamData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "mainEntity": {
      "@type": "Organization",
      "name": "Bankelys",
      "member": [
        {
          "@type": "Person",
          "name": "Nabil El Madani",
          "jobTitle": "Fondateur & CEO",
          "description": "35 années d'expérience en direction bancaire et financière. Ancien DG Banque Zitouna, ancien PDG La Poste Tunisienne.",
          "image": "https://bankelys.com/images/nabil_elmadani.png",
          "sameAs": "https://linkedin.com/in/nabil-elmadani",
          "worksFor": { "@type": "Organization", "name": "Bankelys" }
        },
        {
          "@type": "Person",
          "name": "Sihem Feriani",
          "jobTitle": "Expert Senior en Finance",
          "description": "25 années d'expérience au sein d'Attijari Bank, experte en transformation opérationnelle et conformité.",
          "image": "https://bankelys.com/images/sihem_feriani.png",
          "sameAs": "https://linkedin.com/in/sihem-feriani",
          "worksFor": { "@type": "Organization", "name": "Bankelys" }
        },
        {
          "@type": "Person",
          "name": "Amina Guizani",
          "jobTitle": "Expert Senior en Finance",
          "description": "32 ans d'expérience chez Attijari Bank Tunisie, spécialisée en commerce extérieur et crédits documentaires.",
          "image": "https://bankelys.com/images/amina_guizani.png",
          "sameAs": "https://linkedin.com/in/amina-guizani",
          "worksFor": { "@type": "Organization", "name": "Bankelys" }
        }
      ]
    }
  };

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Accueil",
        "item": "https://bankelys.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Notre Équipe",
        "item": "https://bankelys.com/equipe"
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Notre Équipe — Experts Finance & Banque | Bankelys</title>
        <meta name="description" content="Rencontrez l'équipe Bankelys : Nabil El Madani (35 ans d'expérience bancaire), Sihem Feriani et Amina Guizani, experts en finance à Tunis." />
        <link rel="canonical" href="https://bankelys.com/equipe" />
        <meta property="og:title" content="Notre Équipe d'Experts Financiers — Bankelys" />
        <meta property="og:description" content="Des professionnels avec plus de 90 ans d'expérience combinée en finance bancaire, islamique et commerce international." />
        <meta property="og:url" content="https://bankelys.com/equipe" />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="L'Équipe Bankelys — Experts Finance & Banque" />
        <meta name="twitter:description" content="Rencontrez nos experts : 90+ ans d'expérience combinée en finance bancaire, islamique et commerce international à Tunis." />
      </Helmet>
      <StructuredData data={teamData} />
      <StructuredData data={breadcrumbData} />

      {/* Hero Section */}
      <section className="relative h-[40vh] min-h-[350px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/images/slide7.png"
            alt="Équipe d'experts financiers Bankelys à Tunis"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
        </div>

        <div className="relative z-10 max-w-6xl mx-auto text-center px-6 md:px-10">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-light mb-4 leading-tight text-white">
            Notre Équipe
          </h1>
          <p className="text-base md:text-lg text-white/90 max-w-3xl mx-auto leading-relaxed">
            Des experts passionnés au service de vos projets financiers
          </p>
        </div>
      </section>

      {/* Team Members Section - Minimal top padding */}
      <section className="py-2 md:py-3 px-5 md:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Team Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
            {teamMembers.map((member) => (
              <div
                key={member.id}
                className="bg-white border-2 border-[#dfe3e8] rounded-2xl overflow-hidden
                         transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 group
                         h-full flex flex-col"
              >
                {/* Member Image */}
                <div className="relative h-80 overflow-hidden bg-gradient-to-br from-[#0B2545] to-[#134074]">
                  <img
                    src={member.image}
                    alt={`Portrait de ${member.name}, ${member.role} chez Bankelys`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    style={{ objectPosition: member.imagePosition || 'center top' }}
                  />
                </div>

                {/* Member Info */}
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="text-2xl font-light text-[#0B2545] mb-2">
                    {member.name}
                  </h3>
                  <p className="text-[#B91C1C] font-medium text-sm uppercase tracking-wide mb-4">
                    {member.role}
                  </p>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-1">
                    {member.shortBio}
                  </p>

                  {/* View Profile Button - Fixed at bottom */}
                  <button
                    onClick={() => setSelectedMember(member)}
                    className="w-full bg-[#0B2545] hover:bg-[#0a1f3a] text-white 
                             font-medium text-sm px-6 py-3 rounded-full 
                             transition-all duration-300 hover:shadow-lg
                             flex items-center justify-center gap-2 group/btn mt-auto"
                  >
                    <span>Voir le profil</span>
                    <svg className="w-4 h-4 transition-transform group-hover/btn:translate-x-1" 
                         fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Profile Modal */}
      {selectedMember && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-md"
             onClick={() => setSelectedMember(null)}>
          <div className="relative w-full max-w-4xl mx-auto"
               onClick={(e) => e.stopPropagation()}>
            
            {/* Close Button */}
            <button onClick={() => setSelectedMember(null)}
                    className="absolute -top-3 -right-3 z-30 
                             w-10 h-10 rounded-full 
                             bg-white hover:bg-gray-50 shadow-2xl
                             flex items-center justify-center transition-all duration-300
                             text-gray-600 hover:text-gray-900 hover:scale-110 group">
              <X className="w-5 h-5 transition-transform group-hover:rotate-90 duration-300" />
            </button>

            {/* Modal Content - Single Column */}
            <div className="bg-white shadow-2xl overflow-y-auto rounded-2xl border-2 border-[#0B2545] max-h-[85vh]">
              
              {/* LinkedIn-Style Header */}
              <div className="bg-gradient-to-r from-[#0B2545] to-[#134074] p-8 md:p-10 relative">
                <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                  {/* Profile Photo */}
                  <div className="flex-shrink-0">
                    <div className="w-36 h-36 rounded-full bg-white border-4 border-white shadow-2xl overflow-hidden">
                        <img
                          src={selectedMember.image}
                          alt={`${selectedMember.name}, ${selectedMember.role} chez Bankelys`}
                          className="w-full h-full object-cover"
                          style={{ objectPosition: selectedMember.imagePosition || 'center top' }}
                        />
                    </div>
                  </div>

                  {/* Profile Info */}
                  <div className="flex-1 text-center md:text-left">
                    <h2 className="text-3xl md:text-4xl font-light text-white mb-3 tracking-tight">
                      {selectedMember.name}
                    </h2>
                    <p className="text-[#B91C1C] text-base md:text-lg font-light mb-6 italic">
                      {selectedMember.subRole}
                    </p>
                    
                    {/* LinkedIn Link */}
                    <a href={selectedMember.linkedin} 
                       target="_blank" 
                       rel="noopener noreferrer"
                       className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 
                                text-white px-5 py-2.5 rounded-full text-sm font-medium
                                transition-all duration-300 backdrop-blur-sm
                                hover:scale-105 hover:shadow-lg">
                      <Linkedin className="w-4 h-4" />
                      <span>Profil LinkedIn</span>
                    </a>
                  </div>
                </div>
              </div>

              {/* Full Biography with Enhanced Typography */}
              <div className="p-8 md:p-12 bg-gradient-to-b from-gray-50/30 to-white">
                <div className="max-w-3xl mx-auto">
                  {selectedMember.fullBio.split('\n\n').map((paragraph, idx) => {
                    // Check if paragraph is the quote
                    if (paragraph.includes('« ') && paragraph.includes(' »')) {
                      return (
                        <div key={idx} className="my-10 p-8 bg-gradient-to-br from-[#0B2545]/5 via-white to-[#B91C1C]/5
                                                  rounded-2xl border-l-4 border-[#B91C1C] shadow-sm">
                          <svg className="w-10 h-10 text-[#B91C1C]/20 mb-4" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
                          </svg>
                          <p className="text-lg md:text-xl text-[#0B2545] font-light italic leading-relaxed">
                            {paragraph.replace(/«|»/g, '').trim()}
                          </p>
                        </div>
                      );
                    }
                    
                    // First paragraph - drop cap style with RED first letter
                    if (idx === 0) {
                      return (
                        <p key={idx} className="text-gray-800 leading-[1.8] text-base md:text-lg mb-6 
                                              first-letter:text-6xl first-letter:font-light 
                                              first-letter:text-[#B91C1C] first-letter:mr-2 
                                              first-letter:float-left first-letter:leading-[0.9]">
                          {paragraph}
                        </p>
                      );
                    }
                    
                    return (
                      <p key={idx} className="text-gray-700 leading-[1.8] text-base md:text-lg mb-6 font-light">
                        {paragraph}
                      </p>
                    );
                  })}

                  {/* Bottom Decoration */}
                  <div className="mt-12 pt-8 border-t border-gray-200 flex items-center justify-center">
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 rounded-full bg-[#0B2545]"></div>
                      <div className="w-8 h-0.5 bg-gradient-to-r from-[#0B2545] to-[#B91C1C]"></div>
                      <div className="w-2 h-2 rounded-full bg-[#B91C1C]"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
}